/* Vorschläge beim Tippen — ausschliesslich aus Tags.

   WARUM NICHT SHOPIFYS VORSCHLAGSLISTE

   Die eingebaute Vorschau (`predictive_search`, `/search/suggest`) fragt
   denselben Volltextindex ab, der die Suche unbrauchbar macht: „ecopia"
   liefert dort null Vorschläge, obwohl es das Modell gibt. Eine Vorschlagszeile
   ist ein Versprechen — sie darf nicht aus der Quelle kommen, der wir gerade
   nicht mehr glauben.

   Gearbeitet wird deshalb mit `assets/tire-modelle.json`: Marken und Modelle
   mit ihren Tags und Artikelzahlen, geschrieben von demselben Skript, das die
   Tags an die Produkte hängt. Was hier steht, existiert im Shop — und die
   Zahl neben dem Vorschlag ist die echte Artikelzahl, nicht eine Schätzung.

   Die Liste rechnet im Browser, ohne Netzanfrage je Tastendruck. Das ist
   nebenbei schneller als jede Vorschau: kein Roundtrip, keine Wartezeit,
   keine halbfertigen Zwischenstände.

   ARBEITET MIT tire-modellsuche.js ZUSAMMEN
   Von dort kommen Wortschatz und Adressbau. Ohne jene Datei tut diese nichts. */
(function () {
  'use strict';

  if (window.vantiqVorschlaege) return;
  window.vantiqVorschlaege = true;

  var MAX = 8;          // mehr Zeilen liest niemand, und die Liste deckt die Seite zu
  var AB_ZEICHEN = 2;   // ab einem Zeichen wäre jede Zeile geraten

  function modell() {
    return window.vantiqModell;
  }

  /* --- Suchen ----------------------------------------------------------- */

  /* Ein Eintrag passt, wenn JEDES getippte Wort den Anfang einer seiner
     Vergleichsformen trifft — Marke, Modellname oder eines der Kürzel.

     Wortweise, nicht am Stück: „bridgestone ep" trifft die Marke mit dem
     einen und EP150 mit dem anderen Wort. Ein Vergleich der ganzen Zeichen-
     kette würde hier nichts finden, weil zwischen „bridgestone" und „ep" der
     Modellname „ecopia" steht. */
  function suchen(w, text) {
    var teile = String(text).trim().split(/\s+/).filter(Boolean).map(modell().schluessel);
    teile = teile.filter(Boolean);
    if (!teile.length) return [];

    var treffer = [];
    for (var i = 0; i < w.liste.length; i++) {
      var e = w.liste[i];
      var formen = e.formen;

      var punkte = 0;
      var alle = true;
      for (var t = 0; t < teile.length; t++) {
        var bestes = -1;
        for (var f = 0; f < formen.length; f++) {
          if (formen[f] === teile[t]) {
            bestes = Math.max(bestes, 2);          // ganzes Wort getroffen
          } else if (formen[f].indexOf(teile[t]) === 0) {
            bestes = Math.max(bestes, 1);          // Wortanfang getroffen
          }
        }
        if (bestes < 0) {
          alle = false;
          break;
        }
        punkte += bestes;
      }
      if (!alle) continue;

      /* Eine Marke allein ist ein gröberer Vorschlag als ein Modell — sie
         steht nur oben, wenn wirklich nur die Marke getippt wurde. */
      if (e.art === 'marke' && teile.length > 1) continue;

      treffer.push({ e: e, punkte: punkte });
      if (treffer.length > 400) break;   // die Liste ist nach Grösse sortiert
    }

    treffer.sort(function (a, b) {
      if (b.punkte !== a.punkte) return b.punkte - a.punkte;
      return b.e.zahl - a.e.zahl;
    });
    return treffer.slice(0, MAX).map(function (x) {
      return x.e;
    });
  }

  /* --- Darstellen ------------------------------------------------------- */

  function zeileBauen(e) {
    var li = document.createElement('li');
    li.className = 'kopf__vorschlag';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');

    var a = document.createElement('a');
    if (e.art === 'marke') {
      a.href = modell().markenAdresse(e.marke);
      a.innerHTML =
        '<span class="kopf__vorschlag-name">' + sicher(e.marke) + '</span>' +
        '<span class="kopf__vorschlag-art">' + sicher(window.vantiqText('suggestions.brand')) + '</span>';
    } else {
      a.href = modell().adresseFuer([e.marke, e.tag], e.marke + ' ' + e.text);
      a.innerHTML =
        '<span class="kopf__vorschlag-name">' +
        '<b>' + sicher(e.marke) + '</b> ' + sicher(e.text) +
        '</span>';
    }

    var zahl = document.createElement('span');
    zahl.className = 'kopf__vorschlag-zahl zahl';
    zahl.textContent = e.zahl;
    a.appendChild(zahl);

    li.appendChild(a);
    return li;
  }

  function sicher(text) {
    var d = document.createElement('div');
    d.textContent = String(text == null ? '' : text);
    return d.innerHTML;
  }

  /* Eine getippte Grösse gehört ganz nach oben.

     Sie ist die häufigste Eingabe im Shop überhaupt. tire-groessensuche.js
     fängt sie beim Absenden ohnehin ab — hier wird sie schon beim Tippen
     sichtbar, damit der Kunde sieht, dass er richtig ist. */
  function groessenzeile(text) {
    var g = window.vantiqGroesse && window.vantiqGroesse.lesen(text);
    if (!g) return null;

    var li = document.createElement('li');
    li.className = 'kopf__vorschlag kopf__vorschlag--groesse';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');

    var a = document.createElement('a');
    a.href = window.vantiqGroesse.adresse(g);
    a.innerHTML =
      '<span class="kopf__vorschlag-name">' + sicher(window.vantiqText('suggestions.all_in_size', {
        size: g.breite + '/' + g.quer + ' R' + g.zoll,
      })) + '</span><span class="kopf__vorschlag-art">' +
      sicher(window.vantiqText('suggestions.size')) + '</span>';
    li.appendChild(a);
    return li;
  }

  /* --- Ein Feld verdrahten ---------------------------------------------- */

  function verdrahten(feld) {
    if (feld.dataset.vantiqVorschlag) return;
    feld.dataset.vantiqVorschlag = '1';

    var form = feld.form;
    form.classList.add('kopf__suche--mit-vorschlag');

    var liste = document.createElement('ul');
    liste.className = 'kopf__vorschlaege';
    liste.setAttribute('role', 'listbox');
    liste.hidden = true;
    form.appendChild(liste);

    feld.setAttribute('autocomplete', 'off');
    feld.setAttribute('role', 'combobox');
    feld.setAttribute('aria-expanded', 'false');
    feld.setAttribute('aria-autocomplete', 'list');

    var aktiv = -1;
    var wartend = null;

    function schliessen() {
      liste.hidden = true;
      liste.innerHTML = '';
      aktiv = -1;
      feld.setAttribute('aria-expanded', 'false');
    }

    function markieren(n) {
      var zeilen = liste.querySelectorAll('li');
      if (!zeilen.length) return;
      if (aktiv >= 0 && zeilen[aktiv]) {
        zeilen[aktiv].classList.remove('ist-aktiv');
        zeilen[aktiv].setAttribute('aria-selected', 'false');
      }
      aktiv = (n + zeilen.length) % zeilen.length;
      zeilen[aktiv].classList.add('ist-aktiv');
      zeilen[aktiv].setAttribute('aria-selected', 'true');
      zeilen[aktiv].scrollIntoView({ block: 'nearest' });
    }

    function zeichnen() {
      var text = feld.value.trim();
      if (text.length < AB_ZEICHEN) return schliessen();

      var w = modell().wortschatz();
      if (!w) return schliessen();

      liste.innerHTML = '';
      aktiv = -1;

      var g = groessenzeile(text);
      if (g) liste.appendChild(g);

      suchen(w, text).forEach(function (e) {
        liste.appendChild(zeileBauen(e));
      });

      if (!liste.children.length) return schliessen();
      liste.hidden = false;
      feld.setAttribute('aria-expanded', 'true');
    }

    feld.addEventListener('input', function () {
      /* Kurz warten statt bei jedem Anschlag zu rechnen. Die Suche läuft im
         Browser über knapp 2000 Einträge — das ist schnell, aber bei einem
         schnellen Tipper sind es zehn Durchläufe für ein Wort. */
      clearTimeout(wartend);
      wartend = setTimeout(function () {
        modell().laden().then(zeichnen);
      }, 90);
    });

    feld.addEventListener('keydown', function (e) {
      if (liste.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        markieren(aktiv + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        markieren(aktiv - 1);
      } else if (e.key === 'Enter' && aktiv >= 0) {
        /* Nur wenn wirklich eine Zeile gewählt ist. Sonst gehört Enter dem
           Formular — und damit der Umleitung in tire-modellsuche.js. */
        var link = liste.querySelectorAll('li')[aktiv].querySelector('a');
        if (link) {
          e.preventDefault();
          window.location.href = link.href;
        }
      } else if (e.key === 'Escape') {
        schliessen();
      }
    });

    feld.addEventListener('blur', function () {
      /* Verzögert, sonst ist die Zeile weg, bevor der Klick ankommt. */
      setTimeout(schliessen, 160);
    });
  }

  function alleVerdrahten() {
    Array.prototype.forEach.call(
      document.querySelectorAll('form[role="search"] input[name="q"]'),
      function (feld) {
        if (feld.form) verdrahten(feld);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alleVerdrahten);
  } else {
    alleVerdrahten();
  }
})();
